// extracted by mini-css-extract-plugin
export default {"bottomCtas":"VerifyOtp_bottomCtas__OHHId","waitAndAction":"VerifyOtp_waitAndAction__ggjgQ"};